export const companyLogoFields = `
  name
  domain
  logoUrl
`;
